import GameAnalysisModal from './game-analysis';

export default GameAnalysisModal;
